import React, { Suspense } from 'react';
import { NextUIProvider, Spinner } from '@nextui-org/react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './index.css';
import './globals.css';
import './App.css';
import './styles.css';

// Initialize Sentry
import './lib/sentry';

import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import router from './routes';
import ToastProvider from './components/ToastProvider';
import { setupStore } from './app/store';
import { config } from './env';
import { LogoutWarningModal } from './components/LogoutWarningModal';
import { CustomErrorBoundary } from './lib/sentry';

const store = setupStore();

function Loader() {
  return (
    <div className="loader-container flex items-center justify-center h-screen">
      <Spinner size="lg" />
    </div>
  );
}

// Create root only once
let root: ReturnType<typeof createRoot> | null = null;

function renderApp() {
  const container = document.getElementById('root');
  if (!container) throw new Error('Failed to find the root element');

  if (!root) {
    root = createRoot(container);
  }

  root.render(
    <React.StrictMode>
      <CustomErrorBoundary>
        <GoogleOAuthProvider clientId={config.VITE_CLIENT_ID}>
          <Provider store={store}>
            <NextUIProvider>
              <ToastProvider />
              <Suspense fallback={<Loader />}>
                <LogoutWarningModal />
                <RouterProvider router={router} />
              </Suspense>
            </NextUIProvider>
          </Provider>
        </GoogleOAuthProvider>
      </CustomErrorBoundary>
    </React.StrictMode>
  );
}

renderApp();

// Handle HMR
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    if (root) {
      root.unmount();
      root = null;
    }
  });
}
